export default __webpack_public_path__ + "static/media/linkBlack.e30a28ee.svg";